var _path, _g, _path2, _rect, _rect2, _rect3, _path3, _path4, _path5, _g2, _g3, _path6, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMaintenanceConfig(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 206,
    height: 197,
    viewBox: "0 0 206 197",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_6669_5083",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: -1,
    width: 193,
    height: 198
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M71 196.5L39 176.5L0 22.4998L159.5 -0.000244141L192.5 183L71 196.5Z",
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_6669_5083)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_6669_5083)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M142.016 17.3073L19.5074 32.5648C15.4588 33.069 12.6976 36.9147 13.5141 40.9121L44.202 191.145C44.9343 194.73 48.3044 197.147 51.9349 196.689L173.07 181.435C177.09 180.929 179.842 177.126 179.066 173.15L149.751 22.9131C149.047 19.3019 145.667 16.8526 142.016 17.3073Z",
    fill: "url(#paint0_linear_6669_5083)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.016 17.3073L19.5074 32.5648C15.4588 33.069 12.6976 36.9147 13.5141 40.9121L44.202 191.145C44.9343 194.73 48.3044 197.147 51.9349 196.689L173.07 181.435C177.09 180.929 179.842 177.126 179.066 173.15L149.751 22.9131C149.047 19.3019 145.667 16.8526 142.016 17.3073Z",
    stroke: "white"
  })))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M67.4775 194.011L41.4775 178.011L57.465 174.92C61.4199 174.156 65.2025 176.878 65.7327 180.871L67.4775 194.011Z",
    fill: "#C7D2F6",
    stroke: "white"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 16.3348,
    height: 16.3348,
    rx: 3,
    transform: "matrix(0.992546 -0.121869 0.190809 0.981627 33.2295 61.0264)",
    fill: "url(#paint1_linear_6669_5083)",
    fillOpacity: 0.98
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 16.3348,
    height: 16.3348,
    rx: 3,
    transform: "matrix(0.992546 -0.121869 0.190809 0.981627 39.7783 90.9873)",
    fill: "url(#paint2_linear_6669_5083)",
    fillOpacity: 0.98
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 16.3348,
    height: 16.3348,
    rx: 3,
    transform: "matrix(0.992546 -0.121869 0.190809 0.981627 47.0068 120.948)",
    fill: "url(#paint3_linear_6669_5083)",
    fillOpacity: 0.98
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M75.6689 123.958L151.669 113.958",
    stroke: "url(#paint4_linear_6669_5083)",
    strokeOpacity: 0.8,
    strokeWidth: 8,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M68.7275 95.9795L144.728 85.9795",
    stroke: "url(#paint5_linear_6669_5083)",
    strokeOpacity: 0.8,
    strokeWidth: 8,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M61.6943 64.5889L137.694 54.5889",
    stroke: "url(#paint6_linear_6669_5083)",
    strokeOpacity: 0.8,
    strokeWidth: 8,
    strokeLinecap: "round"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_6669_5083)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M84.9502 8.25272C88.7755 7.78321 92.3655 10.4883 92.9684 14.2949C93.034 14.7093 93.4101 15.0312 93.8267 14.98L104.928 13.617C107.121 13.3477 109.178 14.8983 109.524 17.0802L110.398 22.5974C110.743 24.7792 109.246 26.7664 107.053 27.0356L61.8286 32.5885C59.6361 32.8575 57.5784 31.3069 57.2326 29.1253L56.3588 23.6081C56.0132 21.4263 57.5108 19.4393 59.7032 19.1699L70.8076 17.8064C71.2241 17.7553 71.4868 17.355 71.4212 16.9405C70.8183 13.1338 73.4306 9.66715 77.256 9.19745L84.9502 8.25272Z",
    fill: "url(#paint7_linear_6669_5083)"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_d_6669_5083)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 143.363,
    cy: 89.4279,
    r: 40.5753,
    fill: "url(#paint8_linear_6669_5083)",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 143.363,
    cy: 89.4279,
    r: 36.165,
    stroke: "#4C95FF",
    strokeWidth: 8.82072,
    shapeRendering: "crispEdges"
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M193.061 152.634C195.817 155.39 200.284 155.39 203.04 152.634C205.796 149.878 205.796 145.41 203.04 142.654L193.061 152.634ZM166.296 115.89L161.306 120.879L193.061 152.634L198.051 147.644L203.04 142.654L171.286 110.9L166.296 115.89Z",
    fill: "#4C95FF"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_6669_5083",
    x: 8.87061,
    y: 12.7529,
    width: 174.826,
    height: 188.492,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_6669_5083"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_6669_5083",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_6669_5083",
    x: 53.3093,
    y: 8.19971,
    width: 58.1379,
    height: 28.4192,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -1,
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.06 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_6669_5083"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_6669_5083",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_d_6669_5083",
    x: 88.6749,
    y: 38.2677,
    width: 109.377,
    height: 109.377,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3.52829
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.05658
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_6669_5083"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_6669_5083",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_6669_5083",
    x1: 96.25,
    y1: 16.4998,
    x2: 96.25,
    y2: 197.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DDEBF6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E2E9FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_6669_5083",
    x1: 8.16739,
    y1: 0,
    x2: 8.16739,
    y2: 16.3348,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F5F8FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5F8FE",
    stopOpacity: 0.8
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_6669_5083",
    x1: 8.16739,
    y1: 0,
    x2: 8.16739,
    y2: 16.3348,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F5F8FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5F8FE",
    stopOpacity: 0.8
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_6669_5083",
    x1: 8.16739,
    y1: 0,
    x2: 8.16739,
    y2: 16.3348,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F5F8FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5F8FE",
    stopOpacity: 0.8
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_6669_5083",
    x1: 165.669,
    y1: 106.458,
    x2: 71.6689,
    y2: 118.958,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_6669_5083",
    x1: 158.728,
    y1: 78.4795,
    x2: 64.7275,
    y2: 90.9795,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_6669_5083",
    x1: 151.694,
    y1: 47.0889,
    x2: 57.6943,
    y2: 59.5889,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_6669_5083",
    x1: 113.792,
    y1: 57.8834,
    x2: 85.4526,
    y2: 28.8255,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#82B5FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4C95FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_6669_5083",
    x1: 203.344,
    y1: 130.003,
    x2: 102.788,
    y2: 64.7298,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.75
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0F0F0",
    stopOpacity: 0.07
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMaintenanceConfig);
export default __webpack_public_path__ + "static/media/maintenanceConfig.feb49c6c4e8e08949d890cf8f8904718.svg";
export { ForwardRef as ReactComponent };